import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=550baf3e&"
import script from "./Qualifications.vue?vue&type=script&lang=js&"
export * from "./Qualifications.vue?vue&type=script&lang=js&"
import style0 from "./Qualifications.vue?vue&type=style&index=0&id=550baf3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports